import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faChevronLeft, faPlus, faSearch, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { OpenDialogAddNotificationComponent } from 'app/components/dialog/open-dialog-add-notification/open-dialog-add-notification.component';
import { OpenDialogDeleteItemComponent } from 'app/components/dialog/open-dialog-delete-item/open-dialog-delete-item.component';
import { Push } from 'app/shared/models/class/notification/notification';
import { NotificationService } from 'app/shared/services/notification/notification.service';

@Component({
  selector: 'app-admin-push',
  templateUrl: './admin-push.component.html',
  styleUrls: ['./admin-push.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AdminPushComponent implements OnInit {

  faChevronLeft = faChevronLeft;
  faPlus = faPlus;
  faTimes = faTimes;
  faSearch = faSearch;
  faTrashAlt = faTrashAlt;

  searchForm!: UntypedFormGroup;
  valueInput!: string
  push: Push[] = [];

  displayedColumnsDesktop: string[] = ['date', 'topic', 'title', 'body', 'delete'];
  displayedColumnsMobile: string[] = ['date', 'title', 'delete'];
  dataSource!: MatTableDataSource<Push>;
  expandedElement!: Push | null;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  length!: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent!: PageEvent;

  color: ThemePalette = 'primary';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  applyFilter(filtervalue: any): void {
    this.valueInput = filtervalue.value.trim().toLowerCase();
    this.dataSource.filter = filtervalue.value.trim().toLowerCase();
  }

  resetSearch(): void {
    this.f.keyword.reset();
    this.valueInput = '';
    this.applyFilter({ value: this.valueInput });
  }


  openDialogAddNotification(): void {
    const dialogRef = this.dialog.open(OpenDialogAddNotificationComponent, {
      minWidth: '50%',
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.getPush();
      }
    })
  }

  openDialogDeleteItem(id: string): void {
    const dialogRef = this.dialog.open(OpenDialogDeleteItemComponent, {

      data: {
        title: 'Supprimer la notification',
        text: 'Souhaitez-vous supprimer cette notification ?',
        id,
        component: 'notification',
        confirm: 'La notification a bien été supprimée'
      }
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.getPush();
      }
    })
  }

  updateExpandedElement(element: any): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  private getPush(): void {
    this.notificationService.getPush().subscribe({
      next: push => {
        this.push = push.reverse();
        this.initTable(push)
      }
    })
  }

  private initTable(push: Push[]): void {
    this.dataSource = new MatTableDataSource<Push>(push);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = push?.length;
  }

  private initComponent(): void {
    this.getPush();
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    })
  }

}
